import { Button } from '@presentation/components';
import type { FC } from 'react';
import * as Styled from './styled';
import type { CardItemPartnerProps } from './types';

export * from './types';

export const CardItemPartner: FC<CardItemPartnerProps> = (props) => {
  const { image, title, text, ctaLabel, onClick } = props;

  return (
    <Styled.Card onClick={onClick}>
      {!!image && <img src={image} alt="" />}
      <Styled.ContentTitle>{title}</Styled.ContentTitle>
      <Styled.ContentSubtitle>{text}</Styled.ContentSubtitle>
      <Styled.Footer>
        <Button size="small" color="blue" outlined onClick={onClick}>
          {ctaLabel}
        </Button>
      </Styled.Footer>
    </Styled.Card>
  );
};
